import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-bar-back-button',
  templateUrl: './bar-back-button.component.html',
  styleUrls: ['./bar-back-button.component.css']
})
export class BarBackButtonComponent implements OnInit {

  @Input() link: any[] | string | null | undefined;
  @Input() tooltip = 'Назад';

  constructor() {
  }

  ngOnInit(): void {
  }

}
